module.exports = __webpack_public_path__ + "img/IMG_1458_L_Foamcore_MockedUp.37c401a7.jpg";